import { useNavigate } from "react-router-dom";
import { CheckCircle2, Info, Globe2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { BigButton } from "@/components/BigButton";
import { StatusBadge } from "@/components/StatusBadge";
import { TripInfo } from "@/components/TripInfo";
import { t } from "@/i18n";

export const OrderCard = ({ trip, onChange }) => {
  const nav = useNavigate();
  const accept = async () => {
    try {
      await api.post(`/trips/${trip.id}/accept`);
      toast.success(t("Viaggio {code} accettato. Il vettore è stato avvisato.", { code: trip.code }));
      onChange();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <article className="nv-card p-5 nv-rise" data-testid={`order-card-${trip.code}`}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-display text-2xl font-extrabold tracking-wide">{t("Ordine {code}", { code: trip.code })}</h3>
        <StatusBadge status={trip.status} testId={`order-status-${trip.code}`} />
      </div>
      {trip.international && (
        <span data-testid={`order-intl-${trip.code}`} className="inline-flex mt-2 items-center gap-2 rounded-full px-3 py-1 text-sm font-bold uppercase tracking-wide bg-[#ef0298]/15 text-[#ef0298] border border-[#ef0298]/50">
          <Globe2 className="h-4 w-4" /> {t("Viaggio internazionale")}
        </span>
      )}
      <p className="text-sm text-slate-400 mt-1">{t("Dal vettore: {name}", { name: trip.carrier.name })}</p>
      <TripInfo trip={trip} />
      <div className="grid sm:grid-cols-2 gap-3 mt-3">
        {trip.status === "assegnato" && (
          <BigButton testId={`accept-btn-${trip.code}`} icon={CheckCircle2} color="#ef0298" label={t("Accetta viaggio")} sub={t("Conferma al vettore")} onClick={accept} />
        )}
        <BigButton testId={`details-btn-${trip.code}`} icon={Info} variant="outline" color="#4accff" label={t("Dettagli")} sub={t("Documenti e storico")} onClick={() => nav(`/viaggio/${trip.id}`)} />
      </div>
    </article>
  );
};
